import React, { useEffect, useRef, useState } from "react";
import { AiOutlineMessage, AiOutlinePlus } from "react-icons/ai";
import { GrEmoji } from "react-icons/gr";
import { IoSend } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { add_friend, messageClear, send_message, updateMessage } from "../../store/reducers/chatReducer";
import toast from "react-hot-toast";
import io from "socket.io-client";
import { FaList } from "react-icons/fa";

const socket = io(process.env.NODE_ENV === 'production' ? process.env.REACT_APP_BACKEND_URL : 'http://localhost:5000');


const Chat = () => {
  const originUrl = window.location.origin;
  const scrollRef = useRef();
  const dispatch = useDispatch();
  const { sellerId } = useParams();
  const { userInfo } = useSelector(state => state.auth);
  const { fb_messages, currentFd, my_friends, successMessage } = useSelector(state => state.chat);
  const [text, setText] = useState("");
  const [receverMessage, setReceverMessage] = useState("");
  const [activeSeller, setActiveSeller] = useState([]);
  const [show, setShow] = useState(false);




  // Efecto para conectar usuario al socket
  useEffect(() => {
    if (userInfo && userInfo.id) {
      console.log("Enviando usuario al socket:", userInfo);
      socket.emit("add_user", userInfo.id, userInfo);
    }
  }, [userInfo]);

  // Efecto para cargar amigos cuando se monta el componente
  useEffect(() => {
    if (userInfo?.id) {
      console.log("Intentando cargar amigos para usuario:", userInfo.id);
      dispatch(
        add_friend({
          userId: userInfo.id,
          sellerId: sellerId || null,
        })
      );
    }
  }, [userInfo, dispatch, sellerId]);



  // Efecto para agregar amigo cuando hay sellerId específico
  useEffect(() => {
    if (sellerId && userInfo?.id) {
      dispatch(
        add_friend({
          sellerId: sellerId,
          userId: userInfo.id,
        })
      );
    }
  }, [sellerId, userInfo, dispatch]);




  // Efecto para configurar todos los listeners del socket UNA SOLA VEZ
  useEffect(() => {
    // Listener para mensajes del vendedor
    const handleSellerMessage = (msg) => {
      console.log("Mensaje recibido del vendedor:", msg);
      setReceverMessage(msg);
    };

    // Listener para sellers activos
    const handleActiveSeller = (sellers) => {
      console.log("Sellers activos recibidos del backend:", sellers);
      setActiveSeller(sellers);
    };


    // Configurar listeners
    socket.on("seller_message", handleSellerMessage);
    socket.on("activeSeller", handleActiveSeller);


    // Limpiar listeners
    return () => {
      socket.off("seller_message", handleSellerMessage);
      socket.off("activeSeller", handleActiveSeller);

    };
  }, [sellerId]); // Solo dependemos de sellerId aquí

// Efecto para manejar mensajes recibidos (ahora sin duplicados)
  useEffect(() => {
    if (receverMessage) {
      console.log("Procesando mensaje recibido:", receverMessage);
      
      // Verificar si el mensaje es para el usuario actual y del vendedor actual
      if (sellerId === receverMessage.senderId && userInfo.id === receverMessage.receverId) {
        // Actualizar mensajes en el store
        dispatch(updateMessage(receverMessage));
        
        // Recargar la conversación actual
        if (sellerId) {
          dispatch(
            add_friend({
              sellerId: sellerId,
              userId: userInfo.id,
            })
          );
        }
        
        // Limpiar el mensaje recibido para evitar procesamiento duplicado
        setReceverMessage("");
      } else {
        // Notificación para mensajes de otros vendedores
        toast.success(receverMessage.senderName + " te envió un mensaje");
        setReceverMessage("");
        dispatch(messageClear());
      }
    }
  }, [receverMessage, sellerId, userInfo, dispatch]);

  // Efecto para emitir mensaje al socket cuando se envía exitosamente
  useEffect(() => {
    if (successMessage && fb_messages.length > 0) {
      const lastMessage = fb_messages[fb_messages.length - 1];
      console.log("Emitiendo mensaje al socket:", lastMessage);
      socket.emit("send_customer_message", lastMessage);
      dispatch(messageClear());
    }
  }, [successMessage, fb_messages, dispatch]);

  // Efecto para hacer scroll al último mensaje
  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [fb_messages]);



  // Función para enviar mensaje
  const send = () => {
    if (text.trim() && sellerId) {
      dispatch(
        send_message({
          userId: userInfo.id,
          text,
          sellerId,
          name: userInfo.name,
        })
      );
      setText("");
    } else if (text.trim() && !sellerId) {
      toast.error("Por favor, selecciona un vendedor primero");
    }
  };




  // Función para obtener la lista de vendedores a mostrar
  const getSellersToShow = () => {
    // Eliminar duplicados basados en fdId
    const uniqueSellers = [];
    const seenIds = new Set();
    
    // Primero agregar amigos
    my_friends.forEach(seller => {
      if (!seenIds.has(seller.fdId)) {
        seenIds.add(seller.fdId);
        uniqueSellers.push(seller);
      }
    });
    
    // Luego agregar sellers activos que no sean ya amigos
    activeSeller.forEach(seller => {
      const sellerId = seller.sellerId;
      if (!seenIds.has(sellerId)) {
        seenIds.add(sellerId);
        uniqueSellers.push({
          fdId: sellerId,
          name: seller.userInfo?.name || "Vendedor",
          image: seller.userInfo?.image || `${originUrl}/images/user.png`,
          isActive: true
        });
      }
    });
    
    return uniqueSellers;
  };


   // Función para verificar si un vendedor está activo
  const isSellerActive = (fdId) => {
    return activeSeller.some(c => String(c.sellerId) === String(fdId));
  };

  const sellersToShow = getSellersToShow();


  return (
    <div className="bg-custom-white p-3 rounded-md">
      <div className="w-full flex">
        {/* Panel lateral de vendedores */}
        <div className={`w-[230px] md-lg:absolute bg-white md-lg:h-full -left-[350px] ${show ? "-left-0" : "-left-[350px]"} z-50 transition-all shadow-lg`}>
          <div className="flex justify-center gap-3 items-center text-slate-600 text-xl h-[50px] border-b">
            <span>
              <AiOutlineMessage />
            </span>
            <span>Mensaje</span>
          </div>
          <div className="w-full flex flex-col text-slate-600 py-4 h-[400px] pr-3 overflow-y-auto">
            {sellersToShow.length === 0 ? (
              <div className="text-center text-slate-400 py-8 px-2">
                <AiOutlineMessage className="text-3xl mx-auto mb-2 text-slate-300" />
                <p>No hay vendedores disponibles</p>
                <p className="text-sm mt-1">Los vendedores en línea aparecerán aquí</p>
              </div>
            ) : (
              sellersToShow.map((seller, i) => {
                const isActive = isSellerActive(seller.fdId);
                const isCurrent = currentFd?.fdId === seller.fdId;
                
                return (
                  <Link 
                    to={`/dashboard/chat/${seller.fdId}`} 
                    key={i} 
                    className={`flex gap-3 justify-start items-center pl-3 py-3 hover:bg-slate-50 rounded-lg transition-colors border-b ${isCurrent ? 'bg-blue-50 border-blue-200' : 'border-slate-100'}`}
                    onClick={() => setShow(false)}
                  >
                    <div className="w-[40px] h-[40px] rounded-full relative flex-shrink-0">
                      <img 
                        className="w-full h-full rounded-full object-cover border border-slate-200" 
                        src={seller.image} 
                        alt={seller.name} 
                        onError={(e) => {
                          e.target.src = `${originUrl}/images/user.png`;
                        }}
                      />
                      {isActive && (
                        <div 
                          className="w-[12px] h-[12px] rounded-full bg-green-500 absolute right-0 bottom-0 border-2 border-white" 
                          title="En línea"
                        ></div>
                      )}
                    </div>
                    <div className="flex flex-col flex-grow min-w-0">
                      <span className="font-medium text-sm truncate">{seller.name}</span>
                      <div className="flex items-center gap-1">
                        {isActive ? (
                          <>
                            <span className="text-xs text-green-600 font-medium">En línea</span>
                            <div className="w-1 h-1 rounded-full bg-green-500"></div>
                          </>
                        ) : (
                          <span className="text-xs text-slate-400">Desconectado</span>
                        )}
                      </div>
                    </div>
                  </Link>
                );
              })
            )}
            
            {/* Información sobre sellers activos */}
            {activeSeller.length > 0 && (
              <div className="mt-4 px-3 pt-3 border-t border-slate-100">
                <div className="flex items-center justify-between text-xs text-slate-500">
                  <span>Vendedores en línea</span>
                  <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full font-medium">
                    {activeSeller.length}
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Área principal de chat */}
        <div className="w-[calc(100%-230px)] md-lg:w-full">
          {currentFd ? (
            <div className="w-full h-full">
              {/* Header del chat */}
              <div className="flex justify-between gap-3 items-center text-slate-600 h-[60px] px-4 border-b">
                <div className="flex gap-3 items-center">
                  <div className="w-[40px] h-[40px] rounded-full relative">
                    <img 
                      className="w-full h-full rounded-full object-cover border border-slate-200" 
                      src={currentFd.image || `${originUrl}/images/user.png`} 
                      alt={currentFd.name} 
                    />
                    {isSellerActive(currentFd.fdId) && (
                      <div className="w-[12px] h-[12px] rounded-full bg-green-500 absolute right-0 bottom-0 border-2 border-white"></div>
                    )}
                  </div>
                  <div className="flex flex-col">
                    <span className="font-medium text-lg">{currentFd.name}</span>
                    <div className="flex items-center gap-2">
                      {isSellerActive(currentFd.fdId) ? (
                        <span className="text-xs text-green-600 font-medium flex items-center gap-1">
                          <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
                          En línea • Disponible para chatear
                        </span>
                      ) : (
                        <span className="text-xs text-slate-400">Última vez desconectado</span>
                      )}
                    </div>
                  </div>
                </div>

                <div 
                  onClick={() => setShow(!show)} 
                  className="w-[40px] h-[40px] hidden md-lg:flex cursor-pointer rounded-full justify-center items-center bg-blue-500 text-white hover:bg-blue-600 transition-colors shadow-md"
                  title="Mostrar lista de vendedores"
                >
                  <FaList />
                </div>
              </div>

              {/* Área de mensajes */}
              <div className="h-[400px] w-full bg-gradient-to-b from-slate-50 to-white p-4">
                <div className="w-full h-full overflow-y-auto flex flex-col gap-4">
                  {fb_messages.length === 0 ? (
                    <div className="text-center text-slate-400 py-12">
                      <AiOutlineMessage className="text-4xl mx-auto mb-3 text-slate-300" />
                      <p className="text-lg font-medium text-slate-500">No hay mensajes aún</p>
                      <p className="text-sm text-slate-400 mt-1">
                        {isSellerActive(currentFd.fdId) 
                          ? "¡Envía un mensaje para comenzar la conversación!" 
                          : "El vendedor no está en línea en este momento"}
                      </p>
                    </div>
                  ) : (
                    fb_messages.map((m, i) => {
                      const isMyMessage = currentFd?.fdId === m.receverId;
                      const isLastMessage = i === fb_messages.length - 1;
                      
                      return (
                        <div 
                          ref={isLastMessage ? scrollRef : null} 
                          key={i} 
                          className={`w-full flex gap-3 ${isMyMessage ? 'justify-end' : 'justify-start'}`}
                        >
                          {!isMyMessage && (
                            <img 
                              className="w-[35px] h-[35px] rounded-full flex-shrink-0" 
                              src={`${originUrl}/images/user.png`} 
                              alt="Usuario" 
                            />
                          )}
                          
                          <div className={`max-w-[70%] ${isMyMessage ? 'order-first' : ''}`}>
                            <div className={`p-3 rounded-2xl ${isMyMessage 
                              ? 'bg-blue-500 text-white rounded-br-none' 
                              : 'bg-white text-slate-800 border border-slate-200 rounded-bl-none'
                            } shadow-sm`}>
                              <span className="whitespace-pre-wrap break-words">{m.message}</span>
                            </div>
                            <div className={`text-[10px] text-slate-500 mt-1 px-1 ${isMyMessage ? 'text-right' : 'text-left'}`}>
                              {new Date(m.createdAt || Date.now()).toLocaleTimeString([], { 
                                hour: '2-digit', 
                                minute: '2-digit',
                                hour12: true 
                              })}
                            </div>
                          </div>
                          
                          {isMyMessage && (
                            <img 
                              className="w-[35px] h-[35px] rounded-full flex-shrink-0" 
                              src={`${originUrl}/images/user.png`} 
                              alt="Yo" 
                            />
                          )}
                        </div>
                      );
                    })
                  )}
                </div>
              </div>

              {/* Input para enviar mensajes */}
              <div className="flex p-4 justify-between items-center w-full border-t bg-white">
                <div className="w-[45px] h-[45px] border border-slate-300 p-2 justify-center items-center flex rounded-full cursor-pointer hover:bg-slate-50 transition-colors text-slate-500 hover:text-blue-500">
                  <label className="cursor-pointer" htmlFor="file-input" title="Adjuntar archivo">
                    <AiOutlinePlus className="text-xl" />
                  </label>
                  <input className="hidden" id="file-input" type="file" />
                </div>
                
                <div className="border border-slate-300 h-[45px] ml-2 w-[calc(100%-100px)] rounded-full relative bg-white">
                  <input 
                    value={text} 
                    onChange={e => setText(e.target.value)} 
                    onKeyPress={e => e.key === 'Enter' && send()}
                    type="text" 
                    placeholder={isSellerActive(currentFd.fdId) 
                      ? "Escribe un mensaje..." 
                      : "El vendedor no está en línea. Puedes dejar un mensaje..."} 
                    className="w-full rounded-full h-full outline-none p-3 pr-12 text-slate-700 placeholder-slate-400" 
                    disabled={!isSellerActive(currentFd.fdId)}
                  />
                  <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-xl text-slate-400 hover:text-slate-600 cursor-pointer">
                    <GrEmoji title="Emojis" />
                  </div>
                </div>
                
                <div className="w-[45px] h-[45px] ml-2 justify-center items-center rounded-full">
                  <div 
                    onClick={send} 
                    className={`text-2xl cursor-pointer p-2 rounded-full flex justify-center items-center ${
                      text.trim() && isSellerActive(currentFd.fdId) 
                        ? 'bg-blue-500 text-white hover:bg-blue-600 shadow-md' 
                        : 'text-slate-300 bg-slate-100'
                    } transition-all`}
                    title={!isSellerActive(currentFd.fdId) ? "El vendedor no está en línea" : "Enviar mensaje"}
                  >
                    <IoSend />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div 
              onClick={() => setShow(true)} 
              className="w-full h-[500px] flex flex-col justify-center items-center text-slate-600 cursor-pointer hover:bg-slate-50 transition-colors rounded-lg"
            >
              <div className="bg-blue-50 w-20 h-20 rounded-full flex items-center justify-center mb-4">
                <AiOutlineMessage className="text-3xl text-blue-400" />
              </div>
              <h3 className="text-xl font-bold text-slate-700 mb-2">Seleccione un Vendedor</h3>
              <p className="text-sm font-normal text-slate-500 text-center max-w-md mb-6">
                {activeSeller.length > 0 
                  ? `Hay ${activeSeller.length} vendedor(es) en línea. Haz clic en uno para comenzar a chatear.`
                  : "No hay vendedores en línea en este momento. Intenta más tarde."}
              </p>
              <div 
                onClick={() => setShow(true)} 
                className="px-6 py-3 bg-blue-500 text-white rounded-full font-medium hover:bg-blue-600 transition-colors shadow-md"
              >
                Ver lista de vendedores
              </div>
              
              {activeSeller.length > 0 && (
                <div className="mt-8 flex flex-wrap gap-2 justify-center max-w-lg">
                  {activeSeller.slice(0, 3).map((seller, i) => (
                    <Link
                      key={i}
                      to={`/dashboard/chat/${seller.sellerId}`}
                      className="flex items-center gap-2 bg-white border border-slate-200 rounded-full px-4 py-2 hover:bg-blue-50 hover:border-blue-200 transition-colors shadow-sm"
                    >
                      <div className="w-8 h-8 rounded-full relative">
                        <img 
                          src={seller.userInfo?.image || `${originUrl}/images/user.png`} 
                          alt={seller.userInfo?.name} 
                          className="w-full h-full rounded-full object-cover"
                        />
                        <div className="w-2 h-2 rounded-full bg-green-500 absolute right-0 bottom-0 border border-white"></div>
                      </div>
                      <span className="text-sm font-medium text-slate-700">{seller.userInfo?.name || "Vendedor"}</span>
                    </Link>
                  ))}
                  {activeSeller.length > 3 && (
                    <div className="flex items-center gap-2 bg-slate-100 rounded-full px-4 py-2">
                      <span className="text-sm font-medium text-slate-600">+{activeSeller.length - 3} más</span>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Chat;